import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'restaurants',
        loadComponent: () =>
          import('./features/restaurants/restaurants-list/restaurants-list.component').then(
            (m) => m.RestaurantsListComponent,
          ),
      },
      {
        path: 'restaurants/new',
        loadComponent: () =>
          import('./features/restaurants/restaurant-form/restaurant-form.page').then(
            (m) => m.RestaurantFormPageComponent,
          ),
      },
      {
        path: 'restaurants/:id/edit',
        loadComponent: () =>
          import('./features/restaurants/restaurant-form/restaurant-form.page').then(
            (m) => m.RestaurantFormPageComponent,
          ),
      },
      {
        path: 'subscriptions',
        loadComponent: () =>
          import('./features/subscriptions/subscriptions.component').then(
            (m) => m.SubscriptionsComponent,
          ),
      },
      {
        path: 'admins',
        loadComponent: () =>
          import('./features/admins/admins-list/admins-list.component').then(
            (m) => m.AdminsListComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
